import { makeStyles } from "@material-ui/core/styles";

import { LoginBgUser } from "../../../assets/images";

const useStyles = makeStyles(() => ({
  container: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 1000,
  },

  containerRelative: {
    position: "relative",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    overflow: "hidden",
    width: "100%",
    height: "100vh",
    backgroundImage: `url(${LoginBgUser})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundClip: "border-box",
  },

  formView: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },

  title: {
    fontSize: 34,
    fontWeight: "bold",
    marginBottom: 12,
  },
  subTitle: {
    fontSize: 20,
    marginBottom: 5,
  },

  actions: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    marginTop: 28,
  },

  PixContainer: {
    height: 350,
    width: 350,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

export default useStyles;
